import { useStoryblok } from "$lib/storyblok";
import { cachedUrls } from '$lib/stores.js';

export async function load({ data }) {
    await useStoryblok();
    cachedUrls.set(data.storyUrls);

    return {
        story: data.story,
        href: data.href
    };
}